import React from 'react';

import { req, useApiGet, useApiLoading } from 'react-reqq-lite';

import { formatGetQueryParams } from 'modules/common/utils';
import { getBranchProfile } from 'modules/branch/profile/actions';
import { GET_BRANCH_PROFILE } from 'modules/branch/profile/constant';

import * as actions from './actions';
import * as c from './constants';

export const useGetBranchList = (merchant_uuid, params) => {
  const isApiLoading = useApiLoading(c.GET_BRANCH_LIST, 'get');
  const list = useApiGet(`${c.GET_BRANCH_LIST}.data`, []);
  const pagination = useApiGet(`${c.GET_BRANCH_LIST}.pagination`, {});

  React.useEffect(() => {
    let time;
    if (params) {
      time = setTimeout(() => {
        actions.getBranchList(merchant_uuid, formatGetQueryParams(params));
      }, 300);
    }
    return () => clearTimeout(time);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(params)]);

  return [isApiLoading, list, pagination];
};

export const useGetSelectedBranch = (merchant_uuid, branch_uuid, config) => {
  const { disableAction = false } = config || {};

  const isApiLoading = useApiLoading(GET_BRANCH_PROFILE, 'get');
  const data = useApiGet(GET_BRANCH_PROFILE, {});

  React.useEffect(() => {
    if (disableAction) return null;

    if (merchant_uuid || branch_uuid) {
      getBranchProfile(merchant_uuid, branch_uuid);
    }

    return () => req.set(GET_BRANCH_PROFILE, {});
  }, [merchant_uuid, branch_uuid, disableAction]);

  return [isApiLoading, data];
};
